var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-phone"},[_c('guest-header'),_c('div',{staticClass:"landing"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"auth-card"},[_c('div',{staticClass:"card"},[_vm._t("default")],2)])])]),_c('guest-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }